import Vue from "vue";
import App from "./App.vue";
import Vuelidate from "vuelidate";
import VueTippy from "vue-tippy";

const element = document.getElementById("RFQForm");

if (element) {
  Vue.config.productionTip = false;
  Vue.use(Vuelidate);
  Vue.use(VueTippy);

  new Vue({
    render: createElement => {
      const context = {
        props: { ...element.dataset }
      };
      return createElement(App, context);
    }
  }).$mount("#RFQForm");
}
